module.exports = __webpack_public_path__ + "img/CompScope_Mag_3_Focus_0.8a9bf381.png";